import { render, staticRenderFns } from "./CreditorsV4.vue?vue&type=template&id=b698e4a2&scoped=true"
import script from "./CreditorsV4.vue?vue&type=script&lang=js"
export * from "./CreditorsV4.vue?vue&type=script&lang=js"
import style0 from "./CreditorsV4.vue?vue&type=style&index=0&id=b698e4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b698e4a2",
  null
  
)

export default component.exports